// extracted by mini-css-extract-plugin
export var $animation_name = "_404-module--$animation_name--a71df";
export var pageNotFound = "_404-module--pageNotFound--ab834";
export var pageNotFound__island = "_404-module--pageNotFound__island--d2070";
export var pageNotFound__island___button = "_404-module--pageNotFound__island___button--a15a4";
export var pageNotFound__island___text = "_404-module--pageNotFound__island___text--90e25";